var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockboxWithCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.181,
    height: 107.383,
    viewBox: "0 0 201.181 107.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1384.447 -3921.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.298 3177.825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1121.176,829.747l4.085,5.794a8.626,8.626,0,0,0,6.965,3.656l163.034-.5,12.787-.044a8.542,8.542,0,0,0,7-4.137l2.161-3.037-28.576-21.924-97.861-5.422-61.638,9.025Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.208,831.475a20.945,20.945,0,0,0,1.847-4.958,20.509,20.509,0,0,0,.275-3.791,7.349,7.349,0,0,0-3.254-6.1h0s1.179-12.122-.843-16.514c0,0,.21-.522.472-1.322a9.747,9.747,0,0,0-1.977-9.482l-5.277-5.964c-9.108-10.29-11.982-14.958-25.578-16.955-20.562-3.02-60.564-6.319-78.944,1.517-16.461,7.019-25.228,11.371-31.616,15.068-3.246,1.879-9.332,5.664-12.84,6.957-2.9,1.068-7.36,1.477-10.383,2.145-7.231,1.6-12.262,2.241-19.036,5.058a24.734,24.734,0,0,0-6.2,3.7,16.132,16.132,0,0,0-5.7,13.082l.4,13.527a4.9,4.9,0,0,0,4.814,4.734Z",
    fill: "#15b9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.341,792.095c2.911-1.169,6.677-2.156,9.533-1.073a4.38,4.38,0,0,1,2.721,4.6q-.009.084-.021.168a4.268,4.268,0,0,1-4.342,3.633l-6.964-.151a3.31,3.31,0,0,1-2.53-1.264h0A3.821,3.821,0,0,1,1300.341,792.095Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.127,807.18c1.245-2.35,4.487-6.026,12.878-8.15a1.425,1.425,0,0,1,1.421,2.325c-.407.457-.823.926-1.224,1.375a22.69,22.69,0,0,1-7.084,5.371,19.151,19.151,0,0,1-4.163,1.54A1.694,1.694,0,0,1,1124.127,807.18Z",
    fill: "#f7fefb",
    stroke: "#f7fefb",
    strokeMiterlimit: 10,
    strokeWidth: 0.937
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.7,772.01c-5.5-1.815-28.471-2.347-28.471-2.347a4.869,4.869,0,0,0-5.211,4.07l-2.3,14.232a4.861,4.861,0,0,0,4.815,5.637l21.857-.072c5.261-.017,10.285-4.378,13.228-8.74.068-.1.136-.2.2-.308C1290.571,780.23,1288.509,773.6,1283.7,772.01Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.244,768.472a107.808,107.808,0,0,0-60.374,19.944,3.089,3.089,0,0,0,1.816,5.6l56-.383a5.123,5.123,0,0,0,5.012-4.238l2.617-14.917A5.12,5.12,0,0,0,1237.244,768.472Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.458,788.795c-.222-2.418,7.643-8.768,13.585-6.274,2.336,1.227,3,6.652-3.029,7.868C1190.719,791.457,1185.68,791.212,1185.458,788.795Z",
    fill: "#15b9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.335,801.706l11.28-.039a1.693,1.693,0,0,0,1.683-1.694h0a1.694,1.694,0,0,0-1.695-1.684l-11.279.038a1.7,1.7,0,0,0-1.684,1.695h0A1.7,1.7,0,0,0,1213.335,801.706Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.622,801.562l11.28-.038a1.694,1.694,0,0,0,1.683-1.7h0a1.694,1.694,0,0,0-1.695-1.683l-11.279.038a1.7,1.7,0,0,0-1.684,1.7h0A1.693,1.693,0,0,0,1255.622,801.562Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.366,832.484c0-.163-.006-.325,0-.488.2-11.539,9.365-20.7,20.472-20.473,10.949.229,19.69,9.507,19.745,20.825Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.056,832.888c0-.163-.007-.324,0-.488.2-11.539,9.365-20.705,20.471-20.473,10.949.229,19.691,9.507,19.746,20.825Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.347,
    cy: 17.053,
    rx: 16.347,
    ry: 17.053,
    transform: "translate(1263.63 847.414) rotate(-88.91)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.218,832.022a10.237,10.237,0,1,1-10.039-10A10.022,10.022,0,0,1,1291.218,832.022Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286,831.922a5.014,5.014,0,1,1-4.918-4.9A4.911,4.911,0,0,1,1286,831.922Z",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.347,
    cy: 17.053,
    rx: 16.347,
    ry: 17.053,
    transform: "translate(1143.797 847.82) rotate(-88.91)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.385,832.428a10.237,10.237,0,1,1-10.04-10A10.023,10.023,0,0,1,1171.385,832.428Z",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.168,832.328a5.014,5.014,0,1,1-4.918-4.9A4.91,4.91,0,0,1,1166.168,832.328Z",
    fill: "#26242d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1505 4160)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 368.421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.278,45.936h-3.3V27.569A22.149,22.149,0,0,0,62.861,5.42h0A22.149,22.149,0,0,0,40.72,27.569V45.936h-3.3c-4.747,0-11.078,57.786-11.078,57.786a8.851,8.851,0,0,0,8.6,9.081H90.73a8.846,8.846,0,0,0,8.6-9.081C99.357,103.689,93.033,45.936,88.278,45.936ZM50.627,27.569a12.242,12.242,0,1,1,24.476,0V45.936H50.627ZM88.394,72.006H83.6v8.321H75.747V72.006h-3.3v8.321H64.586V72.006h-3.3v8.321H53.425V72.006H50v8.321H42.124V72.006h-4.8V69.15h4.8V60.829H50V69.15h3.442V60.829H61.3V69.15h3.3V60.829h7.859V69.15h3.3V60.829H83.6V69.15h4.8Z",
    transform: "translate(1436.66 3735.58)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 7,
    transform: "translate(1479 3809.58)",
    fill: "#26242d",
    fontSize: 11,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    "data-name": 2,
    transform: "translate(1491 3809.58)",
    fill: "#26242d",
    fontSize: 11,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    "data-name": 0,
    transform: "translate(1502 3809.58)",
    fill: "#26242d",
    fontSize: 11,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-name": 9,
    transform: "translate(1513 3809.58)",
    fill: "#26242d",
    fontSize: 11,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockboxWithCar);
export default __webpack_public_path__ + "static/media/lockbox-with-car.5e75aafa1ab65af1aa08c9606b3d25c0.svg";
export { ForwardRef as ReactComponent };